<template>
  <div id="routes">
    <Title title="Rutas" subtitle="Vista de rutas planificadas"/>
    <FilterMap :open="viewRouteForm">
      <RoutesForm slot="form"
                  @route-change="changeRoute"
                  @close="handleClose"
                  @loading="handleLoading"
                  @sendLocations="setLocations"></RoutesForm>
      <el-button slot="button"
                 class="btn primary"
                 @click="viewRouteForm = !viewRouteForm">
        <i class="fas fa-angle-left" v-if="viewRouteForm"></i>
        <i class="fas fa-search" v-else></i>
      </el-button>
      <MapRoutes slot="map"
                 :height="'calc(100vh - 220px)'"
                 :locations="routes"
                 :loading="formLoad"
      ></MapRoutes>
    </FilterMap>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import FilterMap from '../components/maps/FilterMap.vue';
import MapRoutes from '../components/maps/MapRoutes.vue';
import RoutesForm from '../components/RoutesForm.vue';

export default {
  name: 'Routes',
  components: {
    Title,
    MapRoutes,
    FilterMap,
    RoutesForm,
  },
  data() {
    return {
      routes: [],
      changeRoutes: false,
      viewRouteForm: true,
      formLoad: false,
      handler: false,
      timeInit: '',
    };
  },
  methods: {
    changeRoute(routes) {
      this.routes = routes;
    },
    handleClose() {
      this.viewRouteForm = false;
    },
    handleLoading(status) {
      this.formLoad = status;
    },
    setLocations(routes) {
      this.routes = routes;
      for (let i = 0; i < this.routes.length; i += 1) {
        if (this.routes[i].delivery_points !== undefined) {
          this.routes[i].delivery_points.sort((a, b) => {
            if (a.route_position > b.route_position) {
              return 1;
            }
            return -1;
          });
        }
      }
      this.routes = routes;
    },
  },
  beforeMount() {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    this.timeInit = `${yyyy}-${mm}-${dd}`;
  },
  watch: {
    routes() {
      this.changeRoutes = true;
      setTimeout(() => {
        this.changeRoutes = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    text-align: left;
    color: $fb-grey-light-97;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .form-map {
    background-color: $fb-grey-light-30;
    padding: 0 15px 15px 15px;
  }
  .content {
    position: relative;
  }
  .action {
    position: absolute;
    top: 60px;
  }
  .close {
    left: -50%;
  }
  .collapseText {
    display: inline;
  }
  @media only screen and (max-width: 425px) {
    .collapseBtn {
      .collapseText {
        display: none;
      }
      &:hover {
        .collapseText {
          display: inline;
        }
      }
    }
  }
</style>
